import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';

import { PropertyService } from '../../services/property.service';
import { NavigationContextService } from '../../services/navigation-context.service';

@Component({
  selector: 'app-external-payment',
  templateUrl: './external-payment.component.html',
  styleUrls: ['./external-payment.component.scss']
})
export class ExternalPaymentComponent implements OnInit {
  possibleMethods = ['Check', 'Cash'];

  payment: { method?: string; amount?: string; paymentDate?: string; description?: string; invoiceId?: string | null } = {
    invoiceId: null,
    method: 'Check',
    amount: '',
    paymentDate: new Date().toISOString().split('T')[0],
    description: ''
  };

  property: any;
  openInvoices: any[] = [];
  loading = true;
  saving = false;
  today = new Date().toISOString().split('T')[0];
  error: string | null = null;

  constructor(
    private propertyService: PropertyService,
    @Optional() public dialogRef: MatDialogRef<ExternalPaymentComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private route: ActivatedRoute,
    private router: Router,
    private navContext: NavigationContextService
  ) {}

  ngOnInit() {
    if (this.data && this.data.property) {
      this.property = this.data.property;
      this.loading = false;
      this.loadOpenInvoices();
      return;
    }
    const propertyId = this.route.snapshot.queryParamMap.get('propertyId');
    if (propertyId) {
      this.propertyService.getPublicProperty(propertyId).then(p => {
        this.property = p;
        this.loading = false;
        this.loadOpenInvoices();
      }).catch(() => {
        this.property = null;
        this.loading = false;
      });
    } else {
      this.property = null;
      this.loading = false;
    }
  }

  /** Unpaid invoices for the "Apply to" selector, oldest first. */
  loadOpenInvoices() {
    if (!this.property || !this.property.id) {
      return;
    }
    this.propertyService.getInvoices(this.property, null, null).then((res: any) => {
      const list = Array.isArray(res) ? res : (res && res.data) || [];
      this.openInvoices = list
        .filter((i: any) => Number(i.remainingBalance) > 0)
        .sort((a: any, b: any) => String(a.dueDate || '').localeCompare(String(b.dueDate || '')));
    }).catch(() => { this.openInvoices = []; });
  }

  cancelAction() {
    if (this.dialogRef) {
      this.dialogRef.close();
      return;
    }
    if (this.property && this.property.id) {
      this.navContext.goToPropertyHub(this.property.id);
      return;
    }
    this.navContext.goToDashboard();
  }

  saveAction() {
    const target = this.property || (this.data && this.data.property);
    if (!target) return;
    this.error = null;
    if (this.payment.paymentDate && this.payment.paymentDate > this.today) {
      this.error = 'Payment date cannot be in the future.';
      return;
    }
    this.saving = true;
    this.propertyService.createPayment(target, this.payment).then(() => {
      this.saving = false;
      if (this.dialogRef) {
        this.dialogRef.close();
      } else {
        this.navContext.goToPropertyHub(target.id);
      }
    }).catch((error) => {
      console.error('Error saving payment:', error);
      this.saving = false;
      const errorMessage = (error && error.error && error.error.error)
        ? error.error.error
        : (error.message || 'Failed to save payment. Please try again.');
      this.error = errorMessage;
      alert(errorMessage);
    });
  }
}
